import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseHideAuthorNameRequest
*  Скрыть или показать имя в своём отзыве.
*/
export class ShowcaseHideAuthorNameRequest extends ActiveModel {

  /**
  * hideAuthorName
  * Не показывать имя автора.  */
  @ActiveField()
  hideAuthorName?: boolean
}
